import { Calendar } from 'lucide-react';
import { formatDateTime, formatDateTimeParts } from '../utils/date';

/**
 * A timestamp as two lines, the way Orders History shows it: the date in the
 * company Date Format over the time in the company Time Format, both in the
 * company timezone. Use it for date columns in grids so every page reads alike.
 * A calendar day with no time of day (see hasTimeOfDay) shows the date alone.
 *
 * Sized to sit quietly beside the rest of a row: 12px, no seconds (they're in
 * the hover title for anyone who needs them), no icon unless asked for.
 */
export default function DateTimeStack({
  value,
  timeZone,
  icon = false,
  empty = '—',
  className = '',
}: {
  value: unknown;
  timeZone?: string;
  /** Show a calendar icon to the left. */
  icon?: boolean;
  /** What to render when there is no date. */
  empty?: string;
  className?: string;
}) {
  const parts = formatDateTimeParts(value, timeZone, { seconds: false });
  if (!parts) return <span className="text-slate-500">{empty}</span>;
  return (
    <div
      className={`flex items-start gap-2 text-xs ${className}`}
      title={parts.time ? formatDateTime(value, timeZone) : undefined}
    >
      {icon && <Calendar size={13} className="mt-px shrink-0 text-slate-500" />}
      <div className="flex flex-col leading-snug whitespace-nowrap">
        <span className="font-medium text-slate-600">{parts.date}</span>
        {parts.time && <span className="text-slate-500">{parts.time}</span>}
      </div>
    </div>
  );
}
